// ANCHOR Model
import createModel, { createSelector } from 'react-scoped-model';

// ANCHOR SWR
import useSWR from 'swr';

// ANCHOR API
import { getFormQuestionAnswers } from '@lyon/utils/api/forms';

interface IProps {
  id: string;
}

export const FormQuestionAnswersData = createModel(({ id }: IProps) => {
  const response = useSWR(
    `/forms-question/${id}/answers`,
    () => getFormQuestionAnswers({ id }),
  );

  return {
    ...response,
  };
}, {
  displayName: 'Models.FormQuestionAnswersData',
});

export const useFormQuestionAnswersData = createSelector(
  FormQuestionAnswersData,
  ({ data }) => data,
);

export const useFormQuestionAnswersMutate = createSelector(
  FormQuestionAnswersData,
  ({ mutate }) => mutate,
);
